<template>
  <div>
    <!-- 车+X -->
    <div v-for="(item, index) in insuranceList" :key="index">
      <div v-if="item.flag && item.attachRiskListParam" class="li-content-x">
        <div class="border-style border-style-xTop">
          <mt-cell class="title-weight" :title="item.productName">
            <img
              :src="trashCan"
              alt=""
              style="width: 0.2rem; height: 0.2rem"
              @click="deleteInsurance(item.productCode)"
            >
          </mt-cell>
        </div>
        <div v-show="carxDetail" style="font-size: 14px">
          <div class="border-styles-X" @click="onScheme(item.productCode)">
            <span class="plan">方案</span>
            <div>
              {{ item.attachRiskListParam.planName }}
              <van-icon
                name="arrow"
                size="9px"
                color="#888"
                dot
                style="margin-right: 0.1rem; margin-top: 0.19rem"
              />
            </div>
          </div>
          <div
            v-if="item.productCode === '0657' ? true : false"
            class="border-styles-X"
            @click="onBaoEscheme(item.productCode)"
          >
            <span class="plan">保额</span>
            <div>
              {{ item.sumInsured.text }}
              <van-icon
                name="arrow"
                size="9px"
                color="#888"
                dot
                style="margin-right: 0.1rem; margin-top: 0.19rem"
              />
            </div>
          </div>
          <div
            v-if="item.productCode === '0666' ? true : false"
            class="border-style"
          >
            <mt-cell title="重度疾病住院护工津贴保险金（保额：9600元）">
              <van-checkbox
                v-model="agreeChecked"
                style="height: 0.14rem; width: 0.14rem"
                icon-size="0.14rem"
                checked-color="#5f2689"
              />
            </mt-cell>
          </div>
          <div class="border-style">
            <mt-cell title="保险起期">
              <span style="color: rgba(102, 102, 102, 1)">{{ startTime }}</span>
            </mt-cell>
          </div>
          <div class="border-style">
            <mt-cell title="保障期限">
              1年
            </mt-cell>
          </div>
          <div
            v-if=" item.fenshuFlag "
            class="border-styles-X"
            @click="onTouBscheme(item.productCode)"
          >
            <span class="plan" style="padding-left: 0">
              <span style="color: #f29600">*</span>
              <span>投保份数</span>
            </span>
            <div>
              {{ item.attachRiskListParam.sumQuantity }}
              <van-icon
                name="arrow"
                size="9px"
                color="#888"
                dot
                style="margin-right: 0.1rem; margin-top: 0.19rem"
              />
            </div>
          </div>
          <div
            v-if="item.productCode === 'ZKICATM_0314'"
            class="border-style-address"
          >
            <div class="home-address">
              <span style="color: #f29600">*</span>
              <span>被保家庭财产地址</span>
            </div>
            <input
              v-model="item.address"
              type="text"
              placeholder="请精确到门牌号"
              @blur="checkAddress(item.address, true,item.productCode)"
            >
          </div>
          <div
            v-if="item.productCode === 'WX0317'"
            class="border-style-address"
          >
            <div class="home-address">
              <span style="color: #f29600">*</span>
              <span>使用燃气家庭地址</span>
            </div>
            <input
              v-model="item.address"
              type="text"
              placeholder="请精确到门牌号"
              @blur="checkAddress(item.address, true,item.productCode)"
            >
          </div>
          <div v-if="item.productCode === 'WX0317' || item.productCode === 'ZKICATM_0314'" class="border-style" style="color: #f00">
            <mt-cell title="如地址不能定位到具体的保险家庭地址可能无法正常理赔" />
          </div>
          <div
            v-if="
              item.productCode === '0653' || item.productCode === '0666'
            "
            class="border-style-address"
            @click="onSheBscheme(item.productCode)"
          >
            <div class="home-address">
              <span style="color: #f29600">*</span>
              <span>有无社保</span>
            </div>
            <div>
              {{ item.conditionParam.isShebaoText }}
              <van-icon
                name="arrow"
                size="9px"
                color="#888"
                dot
                style="margin-right: 10px; margin-top: 17px"
              />
            </div>
          </div>
          <div
            v-if="
              item.productCode === '0653' ||
                item.productCode === '0657' ||
                item.productCode === '0666'
                ? true
                : false
            "
            class="border-style-address"
            @click="onXuBscheme(item.productCode, item)"
          >
            <div class="home-address">
              <span style="color: #f29600">*</span>
              <span>是否续保</span>
            </div>
            <div>
              {{ item.conditionParam.isXuBaoText }}
              <van-icon
                name="arrow"
                size="9px"
                color="#888"
                dot
                style="margin-right: 10px; margin-top: 17px"
              />
            </div>
          </div>
        </div>
        <div class="border-style" :class="xBottom">
          <mt-cell
            title="保费"
          >
            ￥{{ item.attachRiskListParam.sumPremium }}
          </mt-cell>
        </div>
        <div v-show="carxDetail">
          <div class="border-style border-style-xBottom">
            <mt-cell
              title=""
            >
              <span
                @click="showInsuranceClause(item.productCode, 'clause')"
              >《保险条款》</span><span
                @click="showInsuranceClause(item.productCode, 'notice')"
              >《投保须知及声明》</span>
            </mt-cell>
          </div>
        </div>
      </div>
    </div>
    <!-- 车+X 方案选择器 -->
    <van-popup v-model="popupVisible" position="bottom" close-on-click-overlay>
      <van-picker
        :columns="columns"
        show-toolbar
        @confirm="onConfirm"
        @cancel="popupVisible = false"
      />
    </van-popup>
    <!-- 投保份数 -->
    <van-popup
      v-model="popupTBVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-picker
        :columns="TBcolumns"
        show-toolbar
        @confirm="onTouBconfirm"
        @cancel="popupTBVisible = false"
      />
    </van-popup>
    <!-- 个人重疾保额 -->
    <van-popup
      v-model="popupBEVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-picker
        :columns="BEcolumns"
        show-toolbar
        @confirm="onBaoEconfirm"
        @cancel="popupBEVisible = false"
      />
    </van-popup>
    <!-- 有无社保选择器 -->
    <van-popup
      v-model="popupSBVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-picker
        :columns="SBcolumns"
        show-toolbar
        @confirm="onSheBconfirm"
        @cancel="popupSBVisible = false"
      />
    </van-popup>
    <!-- 是否续保选择器 -->
    <van-popup
      v-model="popupXBVisible"
      position="bottom"
      close-on-click-overlay
    >
      <van-picker
        :columns="XBcolumns"
        show-toolbar
        @confirm="onXuBconfirm"
        @cancel="popupXBVisible = false"
      />
    </van-popup>
    <!-- 保险条款、投保须知及声明 -->
    <van-popup
      v-model="insuranceClauseVisible"
      position="bottom"
      :style="{ height: '60%', fontSize: '0.14rem' }"
      v-html="insuranceClauseContent"
    />
    <!-- 不能续保的提示弹框 -->
    <van-popup
      v-model="isXuBao"
      style="border-radius: 8px"
      :close-on-click-overlay="false"
    >
      <div class="TracBackTicket">
        <div class="box">
          <div class="title">
            没有找到您的上年度保单，可能原因：
          </div>
          <div class="context">
            <div>① 上年度保单不在可续保时间范围内</div>
            <div>② 保单号/证件号码输入有误</div>
            <div>③ 上年度投保产品与当前产品不符</div>
          </div>
          <div class="agreeBtn" @click="agree">
            确定
          </div>
        </div>
      </div>
    </van-popup>
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import api from '@/api/api.js'
import Loading from '@/components/Loadings/Loading'
import { mapGetters } from 'vuex'
import { numMulti } from '@/utils/checkFormat.js'
export default {
  components: {
    Loading: Loading
  },
  props: {
    startTime: {
      type: String,
      default: ''
    },
    xBottom: { // 眼睛关闭 底部样式类名
      type: String,
      default: ''
    },
    carxDetail: { // 眼睛关闭 x险部分详情不显示
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      switchs: false,
      insuranceList: [],
      agreeChecked: true,
      perPremium: '', // 单价保费的记录
      perAmount: '', // 单价保额的记录
      isXuBao: false,
      showDetail: api.imgAllUrl + '/openDetail.png',
      selectInsuranceTypes: api.imgAllUrl + '/selectInsuranceTypes.png',
      trashCan: api.imgAllUrl + '/trashCan.png',
      guaranteeBackgroIMG: api.imgAllUrl + '/guaranteeBackgro.png',
      guaranteeTitle: api.imgAllUrl + '/guaranteeTitle.png',
      // 初始化默认值 百万医疗(0666) 靶向药(0653) 个人重疾病(0657)
      productParam: {
        // 靶向药
        '0653': {
          recognizeeInBirthday: this.$store.state.recognizeeIn.birthday,
          recognizeeInSex: this.$store.state.recognizeeIn.sex,
          isShebaoText: '无',
          isShebaoCode: '0',
          isXuBaoText: '否',
          isXuBaoCode: '0'
        },
        // 百万医疗
        '0666': {
          recognizeeInBirthday: this.$store.state.recognizeeIn.birthday,
          recognizeeInSex: this.$store.state.recognizeeIn.sex,
          isShebaoText: '无',
          isShebaoCode: '0',
          isXuBaoText: '否',
          isXuBaoCode: '0',
          isBaoxianText: '不选',
          isBaoxianCode: '1'
        },
        // 个人重疾病
        '0657': {
          recognizeeInBirthday: this.$store.state.recognizeeIn.birthday,
          recognizeeInSex: this.$store.state.recognizeeIn.sex,
          isXuBaoText: '否',
          isXuBaoCode: '0'
        }
      },
      columns: [],
      XBcolumns: [
        {
          text: '否',
          code: '0'
        },
        {
          text: '是',
          code: '1'
        }
      ],
      SBcolumns: [
        {
          text: '无',
          code: '0'
        },
        {
          text: '有',
          code: '1'
        }
      ],
      TBcolumns: [
        {
          text: '1',
          code: '0'
        },
        {
          text: '2',
          code: '1'
        },
        {
          text: '3',
          code: '2'
        },
        {
          text: '4',
          code: '3'
        },
        {
          text: '5',
          code: '4'
        }
      ],
      BEcolumns: [],
      popupVisible: false, // 单项选择器
      popupSBVisible: false, // 有无社保选择器
      popupXBVisible: false, // 是否续保选择器
      popupTBVisible: false, // 投保份数选择器
      popupBEVisible: false, // 个人重疾保额选择器
      insuranceClauseVisible: false, // 保险条款、投保须知及声明显示器
      insuranceClauseContent: '', // 保险条款、投保须知及声明内容
      productPerson: {
        '0657-2': [
          {
            text: '10万重度疾病+3万重度疾病',
            code: 0,
            sum: '100000',
            extra: '30000'
          },
          {
            text: '20万重度疾病+6万重度疾病',
            code: 1,
            sum: '200000',
            extra: '60000'
          },
          {
            text: '30万重度疾病+9万重度疾病',
            code: 2,
            sum: '300000',
            extra: '90000'
          }
        ],
        '0657-1': [
          {
            text: '10万重度疾病',
            code: 0,
            sum: '100000',
            extra: '0'
          },
          {
            text: '20万重度疾病',
            code: 1,
            sum: '200000',
            extra: '0'
          },
          {
            text: '30万重度疾病',
            code: 2,
            sum: '300000',
            extra: '0'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      productXInfoDTOList: 'productXInfoDTOList',
      attachRiskList: 'attachRiskList',
      carPolicySubInfoList: 'carPolicySubInfoList',
      initializeProductXInfoDTOList: 'initializeProductXInfoDTOList'
    })
  },
  watch: {
    productXInfoDTOList: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          this.insuranceList = newVal
          this.insuranceList.forEach(val => {
            this.getFee(val)
          })
        }
      }
    },
    initializeProductXInfoDTOList: {
      deep: true,
      handler(newVal, oldVal) {
        this.getList(3)
      }
    },
    agreeChecked(newVal, oldVal) {
      this.insuranceList.forEach((item) => {
        if (item.productCode === '0666') {
          this.getFee(item)
          this.resetBaoJia()
          // 判断此时百万医疗选中的方案，从方案获取新的kindDtoList，并进行对应的赋值
          item.productPlanDTOList.forEach(val => {
            if (item.attachRiskListParam.planCode === val.projectCode) {
              item.attachRiskListParam.planCodeDtoList = []
              val.kindDtoList.forEach(eve => {
                const obj = {
                  itemCode: eve.itemCode,
                  itemName: eve.itemDetailName,
                  kindCode: eve.kindCode,
                  kindName: eve.kindName
                }
                if (!newVal && eve.kindCode === '060019') {
                  console.log('未选津贴')
                } else {
                  item.attachRiskListParam.planCodeDtoList.push(obj)
                }
              })
            }
          })
          // console.log(538,item.attachRiskListParam);
        }
      })
    },
    startTime(newVal, oldVal) {
      this.insuranceList.forEach((item) => {
        item.attachRiskListParam.startDate = newVal
      })
    }
  },
  created() {
    this.getList(0)
  },
  activated() {
    this.getList(1)
  },
  methods: {
    getList(index) {
      if (this.productXInfoDTOList.length === 0) {
        // 个人重疾险保额的默认方案数组
        this.BEcolumns = JSON.parse(JSON.stringify(this.productPerson['0657-1']))
        if (this.initializeProductXInfoDTOList.length > 0) {
          this.insuranceList = this.initializeProductXInfoDTOList
          this.insuranceList.forEach(item => {
            for (const key in this.productParam) {
              if (key === item.productCode) {
                item.conditionParam = this.productParam[key]
              }
            }
            item.fenshuFlag = false
            item.address = this.$store.state.recognizeeIn.longAddress
            if (item.productCode === '0657') {
              const sumInsuredParam = {
                text: this.BEcolumns[0].text,
                code: this.BEcolumns[0].code,
                sum: this.BEcolumns[0].sum,
                extra: this.BEcolumns[0].extra
              }
              item.sumInsured = sumInsuredParam
            }
            if (item.productCode === '0657') {
              item.conditionParam.sumAmount = this.BEcolumns[0].sum
              item.conditionParam.extra = this.BEcolumns[0].extra
              item.conditionParam.riskKind = '0001'
            }
          })
        }
      }
    },
    // 提示重新报价
    resetBaoJia() {
      this.$emit('price', false)
    },
    // 是否续保选择器 确定函数
    onXuBconfirm(value) {
      this.insuranceList.forEach((item) => {
        if (item.productCode === this.status) {
          if (Number(value.code) === 1) {
            const data = {
              identifyNumber: this.$store.state.recognizeeIn.identifyNumber,
              productCode: item.productCode
            }
            this.$http.post(api.XuBaoFastRenewal, data).then((res) => {
              // console.log(3162, res);
              if (res.data.rtnCode === '0000') {
                item.conditionParam.isXuBaoText = '是'
                item.conditionParam.isXuBaoCode = '1'
                this.getFee(item)
                this.resetBaoJia()
              } else {
                item.conditionParam.isXuBaoText = '否'
                item.conditionParam.isXuBaoCode = '0'
                this.isXuBao = true
              }
            })
          } else {
            item.conditionParam.isXuBaoText = '否'
            item.conditionParam.isXuBaoCode = '0'
            this.getFee(item)
            this.resetBaoJia()
          }
        }
      })
      this.popupXBVisible = false
    },
    // 动态计算保费
    getFee(item) {
      const product = ['0653', '0666', '0657']
      if (product.indexOf(item.productCode) > -1) {
        const conditionRequestDtosParam = {
          condition1: this.$store.state.recognizeeIn.birthday.replace(/-/g, '/') // 被保人出生日期
        }

        const data = {
          channelCode: 'ZKICATM',
          ageRangeFlag: '1',
          feeFlag: '1',
          startDate: this.startTime.substr(0, 10),
          productCode: item.attachRiskListParam.planCode,
          conditionRequestDtos: []
        }
        // /------------------靶向药
        if (item.productCode === '0653') {
          conditionRequestDtosParam.condition2 = item.conditionParam.isShebaoCode === '0' ? '1' : '2'
          conditionRequestDtosParam.condition3 = this.$store.state.recognizeeIn.sex // 被保人性别
          data.conditionRequestDtos.push(conditionRequestDtosParam)
        }
        // /-------------------百万医疗
        if (item.productCode === '0666') {
          conditionRequestDtosParam.condition2 = item.conditionParam.isShebaoCode === '0' ? '1' : '2' // 是否社保
          conditionRequestDtosParam.condition3 = this.agreeChecked ? this.$store.state.recognizeeIn.sex : '3' // 被保人性别
          conditionRequestDtosParam.condition4 = this.agreeChecked ? '0' : '1' // 住院护工津贴
          conditionRequestDtosParam.condition5 = item.conditionParam.isXuBaoCode // 是否续保
          data.conditionRequestDtos.push(conditionRequestDtosParam)
        }
        // /------------------个人重疾病
        if (item.productCode === '0657') {
          conditionRequestDtosParam.condition2 = item.sumInsured.sum // 保额
          conditionRequestDtosParam.condition3 = this.$store.state.recognizeeIn.sex// 被保人性别
          conditionRequestDtosParam.condition4 = item.conditionParam.isXuBaoCode
          conditionRequestDtosParam.condition5 = '0001'
          if (item.attachRiskListParam.planCode === '0657-1') {
            data.conditionRequestDtos.push(conditionRequestDtosParam)
          } else if (item.attachRiskListParam.planCode === '0657-2') {
            const conditionRequestDtosParam2 = JSON.parse(
              JSON.stringify(conditionRequestDtosParam)
            )
            conditionRequestDtosParam2.condition2 = item.sumInsured.extra // 保额
            conditionRequestDtosParam2.condition5 = '0002'
            data.conditionRequestDtos.push(conditionRequestDtosParam)
            data.conditionRequestDtos.push(conditionRequestDtosParam2)
          }
        }
        this.$http.post(api.queryFloatValue, data).then((res) => {
          if (res.data.rtnCode === '0000') {
            this.insuranceList.forEach(val => {
              if (val.productCode === item.productCode) {
                val.attachRiskListParam.sumPremium = res.data.sumPremuim
                val.attachRiskListParam.sumAmount = res.data.sumAmout
              }
            })
          } else {
            this.$toast(res.data.rtnMsg)
          }
        }).catch(res => {
          console.log(res)
        })
      }
    },
    // 有无社保选择器 确定函数
    onSheBconfirm(value) {
      this.insuranceList.forEach((item) => {
        if (item.productCode === this.status) {
          item.conditionParam.isShebaoText = this.SBcolumns[value.code].text
          item.conditionParam.isShebaoCode = this.SBcolumns[value.code].code
          item.attachRiskListParam.socialInsurance = item.conditionParam.isShebaoCode === '0' ? '1' : '2'
          this.getFee(item)
        }
      })
      this.popupSBVisible = false
      this.resetBaoJia()
    },
    // 投保份数选择器 确定函数
    onTouBconfirm(value) {
      this.insuranceList.forEach((item) => {
        if (item.productCode === this.status) {
          item.attachRiskListParam.sumQuantity = this.TBcolumns[
            value.code
          ].text
          // 将显示的总保费改成单价保费*份数
          // 将显示的总保额改成单价保额*份数
          item.attachRiskListParam.sumPremium = numMulti(
            Number(this.perPremium),
            Number(item.attachRiskListParam.sumQuantity)
          )
          item.attachRiskListParam.sumAmount = numMulti(
            Number(this.perAmount),
            Number(item.attachRiskListParam.sumQuantity)
          )
        }
      })
      this.popupTBVisible = false
    },
    // 个人重疾保额选择器 确定函数
    onBaoEconfirm(value) {
      this.insuranceList.forEach((item) => {
        if (item.productCode === '0657') {
          item.sumInsured.text = this.BEcolumns[value.code].text
          item.sumInsured.code = this.BEcolumns[value.code].code
          item.sumInsured.sum = this.BEcolumns[value.code].sum
          item.sumInsured.extra = this.BEcolumns[value.code].extra
          item.conditionParam.sumAmount = item.sumInsured.sum
          item.conditionParam.extra = item.sumInsured.extra
          this.getFee(item)
        }
      })
      this.popupBEVisible = false
      this.resetBaoJia()
    },
    // 删除对应险种的函数
    deleteInsurance(type) {
      this.insuranceList.forEach((item) => {
        if (item.productCode === type) {
          item.flag = false
          this.resetBaoJia()
        }
      })
      this.$store.commit('set_productXInfoDTOList', this.insuranceList)
    },
    // 保险条款、投保须知及声明 内容显示的点击函数
    showInsuranceClause(type, content) {
      this.insuranceClauseContent = ''
      this.switchs = true
      const data = {
        insuredType: this.$store.state.recognizeeIn.insuredNature === '4' ? '2' : '1',
        businessNature: 2,
        productCode: type,
        seatCount: this.$store.state.vehicleInfos.seatCount,
        useNature: this.$store.state.vehicleInfos.useNatureCode,
        carKindCode: this.$store.state.vehicleInfos.carKindCode // 车辆类型编号
      }
      this.$http.post(api.queryProductPlanList, data).then((res) => {
        if (res.data.rtnCode === '0000') {
          const productDetail = JSON.parse(res.data.productDetail)
          if (content === 'clause') {
            this.insuranceClauseContent = productDetail.clobs_clause
          } else if (content === 'notice') {
            this.insuranceClauseContent = productDetail.clobs_notice
          }
        }
        this.switchs = false
        this.insuranceClauseVisible = true
      })
        .catch((error) => {
          console.log(error)
          this.switchs = false
        })
    },
    // 投保份数选择器出现的点击函数
    onTouBscheme(type) {
      if (type === 'ZKICATM0736') {
        this.TBcolumns = [
          {
            text: '1',
            code: 0
          },
          {
            text: '2',
            code: 1
          }
        ]
      }
      if (type === 'ZKICATM_GRDL_Plan') {
        this.TBcolumns = [
          {
            text: '1',
            code: 0
          },
          {
            text: '2',
            code: 1
          },
          {
            text: '3',
            code: 2
          },
          {
            text: '4',
            code: 3
          },
          {
            text: '5',
            code: 4
          }
        ]
      }
      this.popupTBVisible = true
      this.status = type
    },
    // 个人重疾保额选择器出现的点击函数
    onBaoEscheme(type) {
      // console.log("946 this.productPerson",this.productPerson);
      this.insuranceList.forEach((item) => {
        if (item.productCode === type) {
          this.BEcolumns = JSON.parse(JSON.stringify(this.productPerson[
            item.attachRiskListParam.planCode
          ]))
        }
      })
      this.popupBEVisible = true
    },
    // 有无社保选择器出现的点击函数
    onSheBscheme(type) {
      this.popupSBVisible = true
      this.status = type
    },
    // 是否续保选择器出现的点击函数
    onXuBscheme(type, item) {
      this.popupXBVisible = true
      this.status = type
    },
    // 产品方案选择器出现的点击函数
    onScheme(type) {
      this.popupVisible = true
      this.status = type
      this.columns = []
      // 此处逻辑：
      // 循环拿到的方案数组（从后端拿到的数据），type 是谁，则展示谁（产品）对应的方案，this.columns则等于谁
      this.insuranceList.forEach((item) => {
        if (item.productCode === type) {
          item.productPlanDTOList.forEach((value, index) => {
            this.columns.push({
              text: value.projectName,
              code: index
            })
          })
        }
      })
      // 此处逻辑：
      // 让方案选择器弹出时，默认出来的方案是已经选中的方案
      // for (let i in this.schemeData) {
      //   if (this.scheme.code === this.schemeData[i].code) {
      //     this.columns.defaultIndex = Number(i);
      //   }
      // }
    },
    // 不能续保的提示弹框
    agree() {
      this.isXuBao = false
    },
    // 产品方案选择器 确认方案的函数
    onConfirm(value) {
      // console.log(this.insuranceList, 'this.insuranceListthis.insuranceList')
      this.insuranceList.forEach((item) => {
        if (item.productCode === this.status) {
          item.attachRiskListParam.planName =
            item.productPlanDTOList[value.code].projectName
          item.attachRiskListParam.planCode =
            item.productPlanDTOList[value.code].projectCode
          item.attachRiskListParam.riskCode =
            item.productPlanDTOList[value.code].riskCode
          item.attachRiskListParam.commiFee =
            item.productPlanDTOList[value.code].commiFee
          item.attachRiskListParam.sumAmount =
            item.productPlanDTOList[value.code].sumAmount
          item.attachRiskListParam.sumPremium =
            item.productPlanDTOList[value.code].sumPremium
          this.perPremium = item.productPlanDTOList[value.code].sumPremium
          this.perAmount = item.productPlanDTOList[value.code].sumAmount
          // console.log(3493, item.attachRiskListParam);
          if (item.productCode === '0657') {
            item.sumInsured = JSON.parse(JSON.stringify(this.productPerson[
              item.productPlanDTOList[value.code].projectCode
            ][0]))
          }
          this.getFee(item)
          this.resetBaoJia()
          // 驾乘选中广东方案，才显示驾乘投保份数
          // 出行平安意外伤害保险(B款)选中 “交通工具乘客意外险:标准版”，显示投保份数

          if (
            (item.productCode === 'ZKICATM_GRDL_Plan' &&
            item.attachRiskListParam.planCode.substr(0, 3) === '244') || (item.productCode === 'ZKICATM0736' &&
            (item.attachRiskListParam.planCode === '200000736004' || item.attachRiskListParam.planCode === '200000736003'))
          ) {
            item.fenshuFlag = true
          } else {
            item.fenshuFlag = false
            item.attachRiskListParam.sumQuantity = this.TBcolumns[0].text
          }
          // console.log(1015,item.productPlanDTOList);
          if (item.productCode === '0666' || item.productCode === '0653' || item.productCode === '0657') {
            // console.log(1017,item.attachRiskListParam.planCodeDtoList);
            // debugger
            // 重新选择方案时清空planCodeDtoList
            item.attachRiskListParam.planCodeDtoList = []
            item.productPlanDTOList[value.code].kindDtoList.forEach(val => {
              const obj = {
                itemCode: val.itemCode,
                itemName: val.itemDetailName,
                kindCode: val.kindCode,
                kindName: val.kindName
              }
              if (item.productCode === '0666' && !this.agreeChecked && val.kindCode === '060019') {
                console.log('未选津贴')
              } else {
                item.attachRiskListParam.planCodeDtoList.push(obj)
              }
            })
          }
          // console.log(1031,item.attachRiskListParam);
        }
      })
      this.popupVisible = false
    },
    validata() {
      return this.insuranceList
    },
    // 校验地址
    checkAddress(address, judge, product) {
      if (judge) {
        this.resetBaoJia()
        if (address.length < 12) {
          this.$toast('请检查地址：“ ' + address + ' ”是否完善至门牌号')
          this.$emit('address', {
            productCode: product,
            value: false
          })
          return false
        } else {
          this.$emit('address', {
            productCode: product,
            value: true
          })
          return true
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./insurance.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/components/baozhang.vue